import { VYMOBANNER } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import VymoBannerModule from './index';

const module: ModulesList = {
  [VYMOBANNER]: {
    component: VymoBannerModule,
  },
};

export default module;
